// extracted by mini-css-extract-plugin
export default {"tabs":"distributionOfScore_tabs__ihLkq","table":"distributionOfScore_table__NB2Fc"};